import API from '../utils/api';

export const PRACTITIONERS_GET = 'PRACTITIONERS_GET';
export const PRACTITIONERS_GET_SUCCESS = 'PRACTITIONERS_GET_SUCCESS';
export const PRACTITIONERS_GET_FAILED = 'PRACTITIONERS_GET_FAILED';

export const getPractitioners = () => ({
    type: PRACTITIONERS_GET
});

export const getPractitionersSuccess = (branches) => ({
    type: PRACTITIONERS_GET_SUCCESS,
    branches
});

export const getPractitionersFailed = () => ({
    type: PRACTITIONERS_GET_FAILED
});

export const getPractitionersApi = () => (dispatch) => {
    dispatch(getPractitioners());

    return API.get('dental/dentists').then((res) => {
        if (res.status !== 200) {
            dispatch(getPractitionersFailed());

            return;
        }

        res.json().then((json) => {
            dispatch(getPractitionersSuccess(json.data));
        });
    });
};


/** WEBPACK FOOTER **
 ** ./src/actions/practitioners.js
 **/